import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconIncognito$1 = /*@__PURE__*/ proxyCustomElement(class WppIconIncognito extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-incognito", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", fill: "currentColor" }), h("path", { d: "M7.10304 3.99978C6.7109 3.99978 6.35496 4.22898 6.19269 4.58597L5.3463 6.44802C5.20918 6.74968 4.85348 6.88307 4.55182 6.74595C4.25015 6.60883 4.11676 6.25313 4.25388 5.95147L5.10027 4.08942C5.45726 3.30404 6.24034 2.7998 7.10304 2.7998H12.8971C13.7597 2.7998 14.5427 3.30393 14.8998 4.08917L15.7461 5.95047C15.8832 6.25212 15.7499 6.60784 15.4483 6.745C15.1466 6.88215 14.7909 6.74881 14.6537 6.44716L13.8074 4.58586C13.6451 4.22893 13.2892 3.99978 12.8971 3.99978H7.10304ZM5.60008 11.1997C4.27462 11.1997 3.20012 12.2742 3.20012 13.5996C3.20012 14.9251 4.27462 15.9996 5.60008 15.9996C6.92554 15.9996 8.00004 14.9251 8.00004 13.5996C8.00004 12.2742 6.92554 11.1997 5.60008 11.1997ZM2.00014 13.5996C2.00014 11.6114 3.61189 9.99968 5.60008 9.99968C7.45307 9.99968 8.97907 11.3997 9.17804 13.1996H10.822C11.0209 11.3997 12.5469 9.99968 14.3999 9.99968C16.3881 9.99968 17.9999 11.6114 17.9999 13.5996C17.9999 15.5878 16.3881 17.1995 14.3999 17.1995C12.6867 17.1995 11.253 16.0028 10.8892 14.3996H9.11081C8.74703 16.0028 7.31332 17.1995 5.60008 17.1995C3.61189 17.1995 2.00014 15.5878 2.00014 13.5996ZM14.3999 11.1997C13.0745 11.1997 12 12.2742 12 13.5996C12 14.9251 13.0745 15.9996 14.3999 15.9996C15.7254 15.9996 16.7999 14.9251 16.7999 13.5996C16.7999 12.2742 15.7254 11.1997 14.3999 11.1997ZM2.74726 9.17812C6.85062 8.14025 13.1494 8.14022 17.2527 9.17812C17.574 9.25938 17.9003 9.06483 17.9815 8.74358C18.0628 8.42233 17.8682 8.09604 17.547 8.01478C13.2505 6.92802 6.74949 6.92806 2.45301 8.01478C2.13176 8.09604 1.93721 8.42233 2.01846 8.74358C2.09972 9.06482 2.42601 9.25938 2.74726 9.17812Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-incognito-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-incognito", "wpp-icon-incognito-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-incognito-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-incognito-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconIncognito$1);
      }
      break;
  } });
}

const WppIconIncognito = WppIconIncognito$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconIncognito, defineCustomElement };
